import { render, staticRenderFns } from "./AdvAllTpyeStatic.vue?vue&type=template&id=fb15c716&scoped=true&"
import script from "./AdvAllTpyeStatic.vue?vue&type=script&lang=js&"
export * from "./AdvAllTpyeStatic.vue?vue&type=script&lang=js&"
import style0 from "./AdvAllTpyeStatic.vue?vue&type=style&index=0&id=fb15c716&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb15c716",
  null
  
)

export default component.exports